import gql from 'graphql-tag';

export const CreateSignatureMutation = gql`
  mutation createSignature($data: CreateSignatureInput!) {
    createSignature(data: $data) {
      id
    }
  }
`;

export const CompareSignatureMutation = gql`
  mutation compareSignature($data: CompareSignatureInput!) {
    compareSignature(data: $data) {
      id
      phone
      confirmed
    }
  }
`;
